import { render, staticRenderFns } from "./LouverSizingTable.vue?vue&type=template&id=39543f39&scoped=true&"
import script from "./LouverSizingTable.vue?vue&type=script&lang=js&"
export * from "./LouverSizingTable.vue?vue&type=script&lang=js&"
import style0 from "./LouverSizingTable.vue?vue&type=style&index=0&id=39543f39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39543f39",
  null
  
)

export default component.exports